import React, { useRef } from "react";
import {
  diffInDays,
  getDayDiffForCurrentFY,
  minutesToHHMM,
} from "../../../../../Utilitie";
import { FaAngleDoubleDown, FaAngleDoubleUp } from "react-icons/fa";
import DownloadExcel from "../../../../../Extra/DownloadExcel";
import Print from "../../../../../Extra/Print";

const heads = [
  "Demanded",
  "Granted",
  "Availed",
  "Demanded hrs",
  "Granted hrs",
  "Availed hrs",
];

const ComparativeTable = ({ data, date }) => {
  const tableRef = useRef();
  const printRef = useRef();
  const daysDiv = getDayDiffForCurrentFY(date.startDate, date.endDate);
  const tableData = [...data.previousData, ...data.currentData];

  const uniqueMachine = [...new Set(tableData.map((o) => o.Block_Type))];

  // Proper FY sorting
  const uniqueFy = [...new Set(tableData.map((o) => o.F_Year))].sort(
    (a, b) => a.replace("-", "") - b.replace("-", ""),
  );

  return (
    <div>
      <div className="d-flex justify-content-end">
        <Print
          title={`Machine (Eng) - ${date?.startDate}-${date?.endDate}`}
          printRef={printRef}
        />
        <DownloadExcel
          tableRef={tableRef}
          fileName={`Machine (Eng) - ${date?.startDate}-${date?.endDate}`}
        />
      </div>

      <div
        className="table-responsive"
        ref={printRef}
        style={{ maxHeight: "700px", overflow: "auto" }}
      >
        <table className="table table-hover table-striped" ref={tableRef}>
          <thead
            className="table-dark sticky-top align-middle"
            style={{ fontSize: "13px", zIndex: 2 }}
          >
            <tr>
              <th rowSpan={2}>SR</th>
              <th rowSpan={2}>Machine</th>
              {uniqueFy.map((fy, i) => (
                <th key={i} colSpan={6}>
                  {fy}
                </th>
              ))}
              <th colSpan={3}>Variation (count)</th>
              <th rowSpan={2}>Working Days</th>
            </tr>

            <tr>
              {uniqueFy.map((_, l) =>
                heads.map((h, i) => <th key={`${l}-${i}`}>{h}</th>),
              )}
              <th>Demanded</th>
              <th>Granted</th>
              <th>Availed</th>
            </tr>
          </thead>

          <tbody>
            {uniqueMachine.map((machine, m) => {
              const filteredData = tableData.filter(
                (f) => f.Block_Type === machine,
              );

              //  Get FY-wise rows in order
              const fyRows = uniqueFy
                .map((fy) => filteredData.find((f) => f.F_Year === fy))
                .filter(Boolean);

              // get last 2 FY rows (even if missing)
              const lastFy = uniqueFy[uniqueFy.length - 1];
              const prevFy = uniqueFy[uniqueFy.length - 2];

              const current =
                filteredData.find((f) => f.F_Year === lastFy) || {};

              const previous =
                filteredData.find((f) => f.F_Year === prevFy) || {};

              //  Always calculate (fallback = 0)
              const variation = {
                demand:
                  (previous.No_Of_Demand_By_Engg || 0) -
                  (current.No_Of_Demand_By_Engg || 0),

                grant:
                  (previous.No_Of_Demand_Agreed_GIVEN || 0) -
                  (current.No_Of_Demand_Agreed_GIVEN || 0),

                availed:
                  (previous.total_blocks_availed || 0) -
                  (current.total_blocks_availed || 0),
              };
              return (
                <tr key={m} className="justify-center">
                  <td>{m + 1}</td>
                  <td>{machine}</td>

                  {/* FY Data */}
                  {uniqueFy.map((fy, fIndex) => {
                    const row = filteredData.find((f) => f.F_Year === fy);

                    if (row) {
                      return (
                        <React.Fragment key={fIndex}>
                          <td>{row.No_Of_Demand_By_Engg}</td>
                          <td>{row.No_Of_Demand_Agreed_GIVEN}</td>
                          <td>{row.total_blocks_availed}</td>
                          <td>{minutesToHHMM(row.Engg_Demand / 60, true)}</td>
                          <td>
                            {minutesToHHMM(row.granted_duration / 60, true)}
                          </td>
                          <td>
                            {minutesToHHMM(row.availed_duration / 60, true)}
                          </td>
                        </React.Fragment>
                      );
                    } else {
                      return (
                        <React.Fragment key={fIndex}>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                        </React.Fragment>
                      );
                    }
                  })}

                  {/*  Variation Columns */}
                  {["demand", "grant", "availed"].map((key, i) => {
                    const value = variation[key];

                    return (
                      <td key={i}>
                        <div
                          className={`border  rounded ${
                            value < 0
                              ? "border-danger text-danger"
                              : "border-success text-success"
                          }`}
                        >
                          {value < 0 ? (
                            <FaAngleDoubleUp />
                          ) : (
                            <FaAngleDoubleDown />
                          )}
                          {value}
                        </div>
                      </td>
                    );
                  })}

                  <td>
                    {current.total_machine_working_date
                      ? current.total_machine_working_date
                      : 0}
                    /{daysDiv}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ComparativeTable;
